<template>
  <div class="users">
      <Users></Users>
  </div>
</template>

<script>
import Users from "@/components/Users.vue";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: "users",
  components: {
    Users
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>